import {openDialog} from 'platform/components';

import {UserAbsenceFormDialog} from '@dms/features/user-absence';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

interface OpenUserAbsenceCreateDialogParams extends RequiredTestIdProps {
  onSuccess?: () => void;
}

export function openUserAbsenceCreateDialog(params: OpenUserAbsenceCreateDialogParams) {
  openDialog(<UserAbsenceFormDialog {...params} allowUserSelection />, {
    title: `${i18n.t('general.actions.add')} ${i18n.t('user.awayStatus.awayBadge')}`,
  });
}
